// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationLogoDto } from './IOrganizationLogoDto';
import {
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoFromJSONTyped,
    IOrganizationLogoDtoToJSON,
    IOrganizationLogoDtoToJSONTyped,
} from './IOrganizationLogoDto';

/**
 * 
 * @export
 * @interface IPropertiesViewDto
 */
export interface IPropertiesViewDto {
    /**
     * 
     * @type {number}
     * @memberof IPropertiesViewDto
     */
    session_timeout_logout?: number;
    /**
     * 
     * @type {number}
     * @memberof IPropertiesViewDto
     */
    session_timeout_warn?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof IPropertiesViewDto
     */
    communication_channels?: Set<IPropertiesViewDtoCommunicationChannelsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertiesViewDto
     */
    is_reimbursement_allowed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertiesViewDto
     */
    is_bill_pay_allowed?: boolean;
    /**
     * 
     * @type {Set<string>}
     * @memberof IPropertiesViewDto
     */
    allowed_payment_methods?: Set<IPropertiesViewDtoAllowedPaymentMethodsEnum>;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    customer_service_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    customer_service_url_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    customer_service_url_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    customer_service_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertiesViewDto
     */
    customer_service_is_enabled?: boolean;
    /**
     * 
     * @type {IOrganizationLogoDto}
     * @memberof IPropertiesViewDto
     */
    logo_info?: IOrganizationLogoDto;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    statement_type?: IPropertiesViewDtoStatementTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPropertiesViewDto
     */
    ai_confidence_level?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertiesViewDto
     */
    ai_adjudication?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    privacy_policy_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    terms_and_conditions_link?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertiesViewDto
     */
    allow_employees_to_edit_address?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    participant_chatbot_link?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertiesViewDto
     */
    zendesk_sso_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    allow_renewals?: IPropertiesViewDtoAllowRenewalsEnum;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    working_hours?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertiesViewDto
     */
    is_sigis_auto_approve_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    hsa_custodian_type?: IPropertiesViewDtoHsaCustodianTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    custodian_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    custodial_agreement_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertiesViewDto
     */
    investment_terms_url?: string;
}

/**
* @export
* @enum {string}
*/
export enum IPropertiesViewDtoCommunicationChannelsEnum {
    NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
    EMAIL_SMS = 'EMAIL_SMS',
    DATA_EXPORT = 'DATA_EXPORT'
}
/**
* @export
* @enum {string}
*/
export enum IPropertiesViewDtoAllowedPaymentMethodsEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IPropertiesViewDtoStatementTypeEnum {
    PAPER_AND_ELECTRONIC = 'PAPER_AND_ELECTRONIC',
    ELECTRONIC_ONLY = 'ELECTRONIC_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IPropertiesViewDtoAllowRenewalsEnum {
    NO_RENEWALS = 'NO_RENEWALS',
    BY_REQUEST = 'BY_REQUEST'
}
/**
* @export
* @enum {string}
*/
export enum IPropertiesViewDtoHsaCustodianTypeEnum {
    UMB = 'UMB',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IPropertiesViewDto interface.
 */
export function instanceOfIPropertiesViewDto(value: object): value is IPropertiesViewDto {
    return true;
}

export function IPropertiesViewDtoFromJSON(json: any): IPropertiesViewDto {
    return IPropertiesViewDtoFromJSONTyped(json, false);
}

export function IPropertiesViewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPropertiesViewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'session_timeout_logout': json['session_timeout_logout'] == null ? undefined : json['session_timeout_logout'],
        'session_timeout_warn': json['session_timeout_warn'] == null ? undefined : json['session_timeout_warn'],
        'communication_channels': json['communication_channels'] == null ? undefined : new Set(json['communication_channels']),
        'is_reimbursement_allowed': json['is_reimbursement_allowed'] == null ? undefined : json['is_reimbursement_allowed'],
        'is_bill_pay_allowed': json['is_bill_pay_allowed'] == null ? undefined : json['is_bill_pay_allowed'],
        'allowed_payment_methods': json['allowed_payment_methods'] == null ? undefined : new Set(json['allowed_payment_methods']),
        'customer_service_number': json['customer_service_number'] == null ? undefined : json['customer_service_number'],
        'customer_service_url_name': json['customer_service_url_name'] == null ? undefined : json['customer_service_url_name'],
        'customer_service_url_link': json['customer_service_url_link'] == null ? undefined : json['customer_service_url_link'],
        'customer_service_email': json['customer_service_email'] == null ? undefined : json['customer_service_email'],
        'customer_service_is_enabled': json['customer_service_is_enabled'] == null ? undefined : json['customer_service_is_enabled'],
        'logo_info': json['logo_info'] == null ? undefined : IOrganizationLogoDtoFromJSON(json['logo_info']),
        'statement_type': json['statement_type'] == null ? undefined : json['statement_type'],
        'ai_confidence_level': json['ai_confidence_level'] == null ? undefined : json['ai_confidence_level'],
        'ai_adjudication': json['ai_adjudication'] == null ? undefined : json['ai_adjudication'],
        'privacy_policy_link': json['privacy_policy_link'] == null ? undefined : json['privacy_policy_link'],
        'terms_and_conditions_link': json['terms_and_conditions_link'] == null ? undefined : json['terms_and_conditions_link'],
        'allow_employees_to_edit_address': json['allow_employees_to_edit_address'] == null ? undefined : json['allow_employees_to_edit_address'],
        'participant_chatbot_link': json['participant_chatbot_link'] == null ? undefined : json['participant_chatbot_link'],
        'zendesk_sso_enabled': json['zendesk_sso_enabled'] == null ? undefined : json['zendesk_sso_enabled'],
        'allow_renewals': json['allow_renewals'] == null ? undefined : json['allow_renewals'],
        'working_hours': json['working_hours'] == null ? undefined : json['working_hours'],
        'is_sigis_auto_approve_enabled': json['is_sigis_auto_approve_enabled'] == null ? undefined : json['is_sigis_auto_approve_enabled'],
        'hsa_custodian_type': json['hsa_custodian_type'] == null ? undefined : json['hsa_custodian_type'],
        'custodian_name': json['custodian_name'] == null ? undefined : json['custodian_name'],
        'custodial_agreement_url': json['custodial_agreement_url'] == null ? undefined : json['custodial_agreement_url'],
        'investment_terms_url': json['investment_terms_url'] == null ? undefined : json['investment_terms_url'],
    };
}

export function IPropertiesViewDtoToJSON(json: any): IPropertiesViewDto {
    return IPropertiesViewDtoToJSONTyped(json, false);
}

export function IPropertiesViewDtoToJSONTyped(value?: IPropertiesViewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session_timeout_logout': value['session_timeout_logout'],
        'session_timeout_warn': value['session_timeout_warn'],
        'communication_channels': value['communication_channels'] == null ? undefined : Array.from(value['communication_channels'] as Set<any>),
        'is_reimbursement_allowed': value['is_reimbursement_allowed'],
        'is_bill_pay_allowed': value['is_bill_pay_allowed'],
        'allowed_payment_methods': value['allowed_payment_methods'] == null ? undefined : Array.from(value['allowed_payment_methods'] as Set<any>),
        'customer_service_number': value['customer_service_number'],
        'customer_service_url_name': value['customer_service_url_name'],
        'customer_service_url_link': value['customer_service_url_link'],
        'customer_service_email': value['customer_service_email'],
        'customer_service_is_enabled': value['customer_service_is_enabled'],
        'logo_info': IOrganizationLogoDtoToJSON(value['logo_info']),
        'statement_type': value['statement_type'],
        'ai_confidence_level': value['ai_confidence_level'],
        'ai_adjudication': value['ai_adjudication'],
        'privacy_policy_link': value['privacy_policy_link'],
        'terms_and_conditions_link': value['terms_and_conditions_link'],
        'allow_employees_to_edit_address': value['allow_employees_to_edit_address'],
        'participant_chatbot_link': value['participant_chatbot_link'],
        'zendesk_sso_enabled': value['zendesk_sso_enabled'],
        'allow_renewals': value['allow_renewals'],
        'working_hours': value['working_hours'],
        'is_sigis_auto_approve_enabled': value['is_sigis_auto_approve_enabled'],
        'hsa_custodian_type': value['hsa_custodian_type'],
        'custodian_name': value['custodian_name'],
        'custodial_agreement_url': value['custodial_agreement_url'],
        'investment_terms_url': value['investment_terms_url'],
    };
}

